module.exports = __webpack_public_path__ + "static/Man-3f06ca05d7af0299bead1efd4bdc3b4d.svg";